
const BASE_ROW = 104;

const T = {
  bg: "#DBD9D0", text: "#161513", subtext: "#5C5A52",
  accentInk: "#A8380B", // orange for TEXT on light surfaces (the bright accent is only 2.5:1 there)
  panel: "#F1EFE6", panel2: "#E7E4D8", border: "#CBC8BC",
  accent: "#FF5A1F", accentText: "#161513",
  danger: "#C1272D", dangerBg: "#F8E9E7",
  warnBg: "#F0DD9E", warnText: "#161513",
  infoBg: "#D7E1EA", infoText: "#1F3A5F",
  dark: "#141414", darkText: "#FFFFFF", darkSubtext: "#A6A49B", darkChip: "#2A2A2A",
};

const COLORS = [
  { id: "black", fill: "#161513", text: "#FFFFFF" },
  { id: "orange", fill: "#FF5A1F", text: "#161513" },
  { id: "warmgray", fill: "#9C988C", text: "#161513" },
  { id: "cream", fill: "#EDE8DA", text: "#161513" },
  { id: "red", fill: "#C1272D", text: "#FFFFFF" },
  { id: "mustard", fill: "#D9A404", text: "#161513" },
  { id: "navy", fill: "#1F3A5F", text: "#FFFFFF" },
  { id: "forest", fill: "#2F4B3C", text: "#FFFFFF" },
  { id: "slate", fill: "#33363B", text: "#FFFFFF" },
];
const colorOf = (id) => COLORS.find((c) => c.id === id) || COLORS[8];
const ICONS = ["glove", "ropes", "gong", "mic", "corner", "flame", "fist", "belt", "bell"];

function Icon({ id, size = 22, color = "#fff" }) {
  const s = { width: size, height: size, display: "block" };
  const common = { fill: "none", stroke: color, strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" };
  switch (id) {
    case "glove": return (<svg viewBox="0 0 24 24" style={s}><path {...common} d="M7 12V7a2 2 0 0 1 4 0v3M11 10V6a2 2 0 0 1 4 0v4M15 10V7a2 2 0 0 1 4 0v6c0 3.5-2.5 6-6 6H9c-2 0-3-1.2-3-3v-4c0-1.1.9-2 2-2h1" /></svg>);
    case "ropes": return (<svg viewBox="0 0 24 24" style={s}><path {...common} d="M4 6h16M4 12h16M4 18h16" /><path {...common} d="M4 4v16M20 4v16" /></svg>);
    case "gong": return (<svg viewBox="0 0 24 24" style={s}><circle {...common} cx="12" cy="12" r="6.5" /><path {...common} d="M4 6l2.5 2M20 6l-2.5 2M4 18l2.5-2M20 18l-2.5-2" /></svg>);
    case "mic": return (<svg viewBox="0 0 24 24" style={s}><rect {...common} x="9" y="3" width="6" height="11" rx="3" /><path {...common} d="M6 12a6 6 0 0 0 12 0M12 18v3M9 21h6" /></svg>);
    case "corner": return (<svg viewBox="0 0 24 24" style={s}><path {...common} d="M6 21V4M6 4l11 4-11 4" /></svg>);
    case "flame": return (<svg viewBox="0 0 24 24" style={s}><path {...common} d="M12 3c1 3-3 4-3 8a3 3 0 0 0 6 0c0-1-.5-1.7-1-2 .3 2-2 2.6-2-.2C12 6.5 13 5 12 3z" /></svg>);
    case "fist": return (<svg viewBox="0 0 24 24" style={s}><rect {...common} x="6" y="9" width="12" height="9" rx="3" /><path {...common} d="M9 9V7a1.5 1.5 0 0 1 3 0v2M12 9V6.5a1.5 1.5 0 0 1 3 0V9M9 18v1.5M15 18v1.5" /></svg>);
    case "belt": return (<svg viewBox="0 0 24 24" style={s}><path {...common} d="M3 12h6M15 12h6" /><rect {...common} x="9" y="8" width="6" height="8" rx="1.5" /></svg>);
    case "bell": return (<svg viewBox="0 0 24 24" style={s}><path {...common} d="M5 12a7 7 0 0 1 14 0v4H5v-4z" /><path {...common} d="M9 19a3 3 0 0 0 6 0M12 5V3" /></svg>);
    default: return null;
  }
}

// generic lucide-style outline icon, backed by the LUCIDE path map defined
// in icons.snippet.js (inlined ahead of this file)
function LI({ name, size = 16, color = "currentColor", strokeWidth = 2, style }) {
  return React.createElement("svg", {
    width: size, height: size, viewBox: "0 0 24 24", fill: "none",
    stroke: color, strokeWidth, strokeLinecap: "round", strokeLinejoin: "round",
    style, dangerouslySetInnerHTML: { __html: LUCIDE[name] || "" },
  });
}
const Plus = (p) => <LI name="Plus" {...p} />;
const Trash2 = (p) => <LI name="Trash2" {...p} />;
const Pencil = (p) => <LI name="Pencil" {...p} />;
const Check = (p) => <LI name="Check" {...p} />;
const ChevronLeft = (p) => <LI name="ChevronLeft" {...p} />;
const ChevronRight = (p) => <LI name="ChevronRight" {...p} />;
const ChevronUp = (p) => <LI name="ChevronUp" {...p} />;
const ChevronDown = (p) => <LI name="ChevronDown" {...p} />;
const Copy = (p) => <LI name="Copy" {...p} />;
const ClipboardPaste = (p) => <LI name="ClipboardPaste" {...p} />;
const X = (p) => <LI name="X" {...p} />;
const Save = (p) => <LI name="Save" {...p} />;
const Loader2 = (p) => <LI name="Loader2" {...p} />;
const Split = (p) => <LI name="Split" {...p} />;
const Lock = (p) => <LI name="Lock" {...p} />;
const Unlock = (p) => <LI name="Unlock" {...p} />;
const LayoutTemplate = (p) => <LI name="LayoutTemplate" {...p} />;
const StarIcon = (p) => <LI name="Star" {...p} />;
const ImageIcon = (p) => <LI name="Image" {...p} />;
const SearchIcon = (p) => <LI name="Search" {...p} />;
const Eye = (p) => <LI name="Eye" {...p} />;
const EyeOff = (p) => <LI name="EyeOff" {...p} />;
const Undo2 = (p) => <LI name="Undo2" {...p} />;
const Redo2 = (p) => <LI name="Redo2" {...p} />;
const ArrowLeft = (p) => <LI name="ArrowLeft" {...p} />;
const Radio = (p) => <LI name="Radio" {...p} />;
const PanelBottom = (p) => <LI name="PanelBottom" {...p} />;
const PanelRight = (p) => <LI name="PanelRight" {...p} />;
const CalendarIcon = (p) => <LI name="Calendar" {...p} />;
const HomeIcon = (p) => <LI name="House" {...p} />;
const MenuIcon = (p) => <LI name="Menu" {...p} />;
const PanelLeftClose = (p) => <LI name="PanelLeftClose" {...p} />;
const GripVertical = (p) => <LI name="GripVertical" {...p} />;
const LayersIcon = (p) => <LI name="Layers" {...p} />;

// icons for sign-in, admin, history and notices
const ShieldIcon = (p) => <LI name="Shield" {...p} />;
const LogOutIcon = (p) => <LI name="LogOut" {...p} />;
const HistoryIcon = (p) => <LI name="History" {...p} />;
const SettingsIcon = (p) => <LI name="Settings" {...p} />;
const KeyIcon = (p) => <LI name="KeyRound" {...p} />;
const TextSizeIcon = (p) => <LI name="TextSize" {...p} />;
const AlertIcon = (p) => <LI name="AlertTriangle" {...p} />;
const UserPlusIcon = (p) => <LI name="UserPlus" {...p} />;
const RefreshIcon = (p) => <LI name="RefreshCw" {...p} />;
const UsersIcon = (p) => <LI name="Users" {...p} />;

// The site's logo: the cue playing now, then what's next and later — which
// also reads as a ring's ropes. Same drawing as public/favicon.svg.
function Logo({ size = 34 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" style={{ display: "block", flex: "0 0 auto" }}>
      <rect width="64" height="64" rx="14" fill={T.accent} />
      <path d="M14 13.5 L26 21 L14 28.5 Z" fill={T.text} stroke={T.text} strokeWidth="2" strokeLinejoin="round" />
      <rect x="30" y="17.5" width="21" height="7" rx="3.5" fill={T.text} />
      <rect x="13" y="32" width="38" height="7" rx="3.5" fill={T.text} fillOpacity="0.62" />
      <rect x="13" y="45" width="38" height="7" rx="3.5" fill={T.text} fillOpacity="0.32" />
    </svg>
  );
}

export { Logo, ShieldIcon, LogOutIcon, HistoryIcon, SettingsIcon, KeyIcon, TextSizeIcon, AlertIcon, UserPlusIcon, RefreshIcon, UsersIcon, BASE_ROW, T, COLORS, colorOf, ICONS, Icon, LI, Plus, Trash2, Pencil, Check, ChevronLeft, ChevronRight, ChevronUp, ChevronDown, Copy, ClipboardPaste, X, Save, Loader2, Split, Lock, Unlock, LayoutTemplate, StarIcon, ImageIcon, SearchIcon, Eye, EyeOff, Undo2, Redo2, ArrowLeft, Radio, PanelBottom, PanelRight, CalendarIcon, HomeIcon, MenuIcon, PanelLeftClose, GripVertical, LayersIcon };
